import React from 'react';
import { StyledTable } from './TableColumnStyle';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { Link } from 'react-router-dom';

export const requestsColumns = ({
                                  t,
                                  lang,
                                  pageNumber,
                                  filter,
                                  downloadApplication,
                                  modalRevoke,
                                  modalRejectVoucher,
                                  checkBulletins,
                                  modalInterested,
                                  type
                                }) => {
  return [
    {
      Cell: row => (
        <Column
          data={row.original}
          index={row.index}
          t={t}
          lang={lang}
          pageNumber={pageNumber}
          modalRevoke={modalRevoke}
          modalRejectVoucher={modalRejectVoucher}
          filter={filter}
          downloadApplication={downloadApplication}
          checkBulletins={checkBulletins}
          modalInterested={modalInterested}
          type={type}
        />
      )
    }
  ];
};

const Column = ({
  data,
  t,
  lang,
  modalRevoke,
  pageNumber,
  filter,
  index,
  downloadApplication,
  modalRejectVoucher,
  checkBulletins,
  modalInterested,
                  type
}) => {
  return (
    <StyledTable>
      <div className="row1">
        <div className="col1">
          <div>
            <b>{(pageNumber - 1) * filter.pageSize + index + 1}) </b>
            <b>{t('voucher_applications_childFIO')}:</b>{' '}
            {`${data.childSurname || ''} ${data.childName || ''} ${data.childMiddleName ||
              ''}`}
          </div>
        </div>
        <div className="col2">
          <div style={{ marginBottom: '5px' }}>
            {data.appStatusWebStatus && data.appStatusWebStatus[`${lang}_name`]}
          </div>
        </div>
      </div>
      <div className="row2">
        <div className="col2_1">
          <div>
            <b>{t('voucher_applications_childBirthday')}:</b>{' '}
            {moment(data.childBirthday).format('DD.MM.YYYY')}
          </div>
          <div>
            <b>{t('voucher_applications_childIin')}:</b> {data.childIin}
          </div>
          {data.position && (
            <Link
              to={`/queue-applications?filter=${JSON.stringify({
                pageNumber: 1,
                pageSize: 10,
                priorityCategory: data.priorityCategory,
                queuedRegion: data.queuedRegion,
                queuedType: data.queuedType,
                rehabType: data.rehabType,
                correctionType: data.correctionType,
                childYearBirth: !(
                  ['1910'].includes(data.queuedRegion.slice(0, 4)) &&
                  data.queuedType === 'general'
                )
                  ? moment(data.childBirthday).year()
                  : null
              })}`}
            >
              <div>
                <b>{t('voucher_applications_queuedNumber')}:</b> {data.position}
              </div>
            </Link>
          )}
          <div>
            <b>{t('kindergarten_applications_application_number')}:</b>{' '}
            {data.requestFormId}
          </div>
          <div>
            <b>{t('kindergarten_applications_queue_type')}:</b>{' '}
            {data.queuedTypeStatus && data.queuedTypeStatus[`${lang}_name`]}
          </div>
          <div>
            <b>{t('voucher_applications_priorityCategory')}:</b>{' '}
            {data.priorityCategory && data.priorityCategory[`${lang}_name`]}
          </div>
          <div>
            <b>{t('kindergarten_applications_region')}</b>{' '}
            {data.providerLocation[`${lang}_name`]}
          </div>
        </div>
        <div className="col2_2">
          {data.submissionDate && (
            <div>
              <b>{t('voucher_application_submissionDate')}:</b>{' '}
              {moment(data.submissionDate).format('DD.MM.YYYY')}
            </div>
          )}
          {data.acceptVoucherDeadline && (
            <>
              <b>{t('voucher_application_acceptVoucherDeadline')}:</b>{' '}
              {moment(data.acceptVoucherDeadline).format('DD.MM.YYYY')}
            </>
          )}
        </div>
        <div className="col2_3">
          {data?.appStatus && ['STOP_LIST_DC'].includes(data.appStatus) && (
            // Заинтересован
            <div style={{ paddingTop: '10px' }}>
              <Button
                onClick={() => modalInterested.open(data)}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but"
              >
                {t('voucher_applications_actionsInterested')}
              </Button>
            </div>
          )}
          {data && ['ASSIGN_VOUCHER'].includes(data.appStatus) ? (
            <>
              <div>
                <Button
                  style={{ marginBottom: '10px' }}
                  onClick={() => checkBulletins(data)}
                  variant="contained"
                  color="secondary"
                  size="small"
                  className="tab_but"
                >
                  {t('voucher_applications_actionsGetVoucher')}
                </Button>
              </div>
              <div>
                <Button
                  onClick={() => modalRejectVoucher.open(data)}
                  variant="contained"
                  size="small"
                  className="tab_but--reject"
                >
                  {t('voucher_applications_actionsRejectVoucher')}
                </Button>
              </div>
            </>
          ) : null}
          {data && ['IN_QUEUED'].includes(data.appStatus) ? (
            // Отозвать заявление из очереди
            <div style={{ paddingTop: '10px' }}>
              <Button
                onClick={() => modalRevoke.open(data)}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but_revoke"
              >
                {t('voucher_applications_actionsRevoke')}
              </Button>
            </div>
          ) : null}
          {data.requestFormId && (
            <div style={{ paddingTop: '10px' }}>
              <Button
                onClick={() => downloadApplication(data.requestFormId)}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but"
              >
                {t('voucher_applications_actionsDownload')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </StyledTable>
  );
};
